import type { TherapistType } from '@/legacy-src/types/TherapistStateType'

import { OFFLINE_NOT_AVAILABLE } from '@/src/domains/client-booking/constants'
import { useFreeSlotTypeQueryFilter } from '@/src/domains/client-booking/hooks/useFreeSlotTypeQueryFilter'
import type { FreeSlotTypeFilterWithAvailability } from '@/src/domains/client-booking/types'

import { useIsClientOfflineBookingAvailable } from './useIsClientOfflineBookingAvailable'

export interface UseFreeSlotTypeQueryFilterWithAvailability {
  therapist: TherapistType
}

export const useFreeSlotTypeQueryFilterWithAvailability = ({
  therapist,
}: UseFreeSlotTypeQueryFilterWithAvailability): Omit<ReturnType<typeof useFreeSlotTypeQueryFilter>, 'filter'> & {
  filter: FreeSlotTypeFilterWithAvailability
} => {
  const props = useFreeSlotTypeQueryFilter()

  const isOfflineAvailable = useIsClientOfflineBookingAvailable({ therapist })

  if (isOfflineAvailable) {
    return props
  }

  return { ...props, filter: OFFLINE_NOT_AVAILABLE }
}
